// extracted by mini-css-extract-plugin
module.exports = {"detail":"refund_detail__4V2ks","field":"refund_field__3xWD8","verifyButton":"refund_verifyButton__2I3ER","rejected":"refund_rejected__38u8z"};